// extracted by mini-css-extract-plugin
module.exports = {"job-board-jobs-list":"JobsList_job-board-jobs-list__IK9NS"};